import AxiosPermisos from "./../axiosPermisos";

import { path } from "./path";

import { map_query } from "@/core/functions/map-path-query";

async function getCount(data = {}) {
  let url = path.count;
  url = url.concat(map_query(data))
  return await AxiosPermisos.get(url, true)
}

export { getCount };
